var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import WalletUnlockActions from "actions/WalletUnlockActions";

import WalletDb from "stores/WalletDb";
import { Aes, ChainValidation, TransactionBuilder, TransactionHelper, FetchChain, ChainStore } from "bitsharesjs";
import counterpart from "counterpart";
import { Notification } from "bitshares-ui-style-guide";

var ApplicationApi = {
    create_account: function create_account(owner_pubkey, active_pubkey, memo_pubkey, new_account_name, registrar, referrer, referrer_percent) {
        var broadcast = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

        ChainValidation.required(registrar, "registrar_id");
        ChainValidation.required(referrer, "referrer_id");

        return new Promise(function (resolve, reject) {
            return Promise.all([FetchChain("getAccount", registrar), FetchChain("getAccount", referrer)]).then(function (res) {
                var _res = _slicedToArray(res, 2),
                    chain_registrar = _res[0],
                    chain_referrer = _res[1];

                var tr = new TransactionBuilder();
                tr.add_type_operation("account_create", {
                    fee: {
                        amount: 0,
                        asset_id: 0
                    },
                    registrar: chain_registrar.get("id"),
                    referrer: chain_referrer.get("id"),
                    referrer_percent: referrer_percent,
                    name: new_account_name,
                    owner: {
                        weight_threshold: 1,
                        account_auths: [],
                        key_auths: [[owner_pubkey, 1]],
                        address_auths: []
                    },
                    active: {
                        weight_threshold: 1,
                        account_auths: [],
                        key_auths: [[active_pubkey, 1]],
                        address_auths: []
                    },
                    options: {
                        memo_key: memo_pubkey,
                        voting_account: "1.2.5",
                        num_witness: 0,
                        num_committee: 0,
                        votes: []
                    }
                });
                return WalletDb.process_transaction(tr, null, //signer_private_keys,
                broadcast).then(function (res) {
                    console.log("process_transaction then", res);
                    resolve();
                }).catch(function (err) {
                    console.log("process_transaction catch", err);
                    reject(err);
                });
            });
        });
    },
    _get_memo_keys: function _get_memo_keys(account) {
        var with_private_keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var memo = {
            public_key: null,
            private_key: null
        };
        memo.public_key = account.getIn(["options", "memo_key"]);
        // The 1s are base58 for all zeros (null)
        if (/111111111111111111111/.test(memo.public_key)) {
            memo.public_key = null;
        }
        if (with_private_keys) {
            memo.private_key = WalletDb.getPrivateKey(memo.public_key);
            if (!memo.private_key) {
                Notification.error({
                    message: counterpart.translate("account.errors.memo_missing")
                });
                throw new Error("Missing private memo key for sender: " + account.get("name"));
            }
        }
        return memo;
    },
    _create_transfer_op: function _create_transfer_op(_ref) {
        var _this = this;

        var from_account = _ref.from_account,
            to_account = _ref.to_account,
            amount = _ref.amount,
            asset = _ref.asset,
            memo = _ref.memo,
            _ref$propose_account = _ref.propose_account,
            propose_account = _ref$propose_account === undefined ? null : _ref$propose_account,
            _ref$encrypt_memo = _ref.encrypt_memo,
            encrypt_memo = _ref$encrypt_memo === undefined ? true : _ref$encrypt_memo,
            _ref$optional_nonce = _ref.optional_nonce,
            optional_nonce = _ref$optional_nonce === undefined ? null : _ref$optional_nonce,
            _ref$fee_asset_id = _ref.fee_asset_id,
            fee_asset_id = _ref$fee_asset_id === undefined ? "1.3.0" : _ref$fee_asset_id,
            _ref$transactionBuild = _ref.transactionBuilder,
            transactionBuilder = _ref$transactionBuild === undefined ? null : _ref$transactionBuild;

        var unlock_promise = WalletUnlockActions.unlock();

        var memo_sender_account = propose_account || from_account;
        return Promise.all([FetchChain("getAccount", from_account), FetchChain("getAccount", to_account), FetchChain("getAccount", memo_sender_account), FetchChain("getAsset", asset), FetchChain("getAsset", fee_asset_id), unlock_promise]).then(function (res) {
            var _res2 = _slicedToArray(res, 5),
                chain_from = _res2[0],
                chain_to = _res2[1],
                chain_memo_sender = _res2[2],
                chain_asset = _res2[3],
                chain_fee_asset = _res2[4];

            var chain_propose_account = null;
            if (propose_account) {
                chain_propose_account = chain_memo_sender;
            }

            var memo_object = void 0;
            if (memo) {
                var memo_sender = _this._get_memo_keys(chain_memo_sender, encrypt_memo);
                var memo_to = _this._get_memo_keys(chain_to, false);
                if (!!memo_sender.public_key && !!memo_to.public_key) {
                    var nonce = optional_nonce == null ? TransactionHelper.unique_nonce_uint64() : optional_nonce;
                    memo_object = {
                        from: memo_sender.public_key,
                        to: memo_to.public_key,
                        nonce: nonce,
                        message: encrypt_memo ? Aes.encrypt_with_checksum(memo_sender.private_key, memo_to.public_key, nonce, memo) : Buffer.isBuffer(memo) ? memo.toString("utf-8") : memo
                    };
                }
            }

            // Allow user to choose asset with which to pay fees #356
            var fee_asset = chain_fee_asset.toJS();

            // Default to CORE in case of faulty core_exchange_rate
            if (fee_asset.options.core_exchange_rate.base.asset_id === "1.3.0" && fee_asset.options.core_exchange_rate.quote.asset_id === "1.3.0") {
                fee_asset_id = "1.3.0";
            }

            var tr = null;
            if (transactionBuilder == null) {
                tr = new TransactionBuilder();
            } else {
                tr = transactionBuilder;
            }

            var transfer_op = tr.get_type_operation("transfer", {
                fee: {
                    amount: 0,
                    asset_id: fee_asset_id
                },
                from: chain_from.get("id"),
                to: chain_to.get("id"),
                amount: { amount: amount, asset_id: chain_asset.get("id") },
                memo: memo_object
            });
            if (__DEV__) {
                console.log("built transfer", transfer_op, tr);
            }
            return {
                transfer_op: transfer_op,
                chain_from: chain_from,
                chain_to: chain_to,
                chain_propose_account: chain_propose_account,
                chain_memo_sender: chain_memo_sender,
                chain_asset: chain_asset,
                chain_fee_asset: chain_fee_asset
            };
        }).catch(function (err) {
            console.error(err);
        });
    },


    /**
     @param propose_account (or null) pays the fee to create the proposal, also used as memo from
     */
    transfer: function transfer(_ref2) {
        var from_account = _ref2.from_account,
            to_account = _ref2.to_account,
            amount = _ref2.amount,
            asset = _ref2.asset,
            memo = _ref2.memo,
            _ref2$broadcast = _ref2.broadcast,
            broadcast = _ref2$broadcast === undefined ? true : _ref2$broadcast,
            _ref2$encrypt_memo = _ref2.encrypt_memo,
            encrypt_memo = _ref2$encrypt_memo === undefined ? true : _ref2$encrypt_memo,
            _ref2$optional_nonce = _ref2.optional_nonce,
            optional_nonce = _ref2$optional_nonce === undefined ? null : _ref2$optional_nonce,
            _ref2$propose_account = _ref2.propose_account,
            propose_account = _ref2$propose_account === undefined ? null : _ref2$propose_account,
            _ref2$fee_asset_id = _ref2.fee_asset_id,
            fee_asset_id = _ref2$fee_asset_id === undefined ? "1.3.0" : _ref2$fee_asset_id,
            _ref2$transactionBuil = _ref2.transactionBuilder,
            transactionBuilder = _ref2$transactionBuil === undefined ? null : _ref2$transactionBuil;

        if (transactionBuilder == null) {
            transactionBuilder = new TransactionBuilder();
        }
        return this._create_transfer_op({
            from_account: from_account,
            to_account: to_account,
            amount: amount,
            asset: asset,
            memo: memo,
            propose_account: propose_account,
            encrypt_memo: encrypt_memo,
            optional_nonce: optional_nonce,
            fee_asset_id: fee_asset_id,
            transactionBuilder: transactionBuilder
        }).then(function (transfer_obj) {
            return transactionBuilder.update_head_block().then(function () {
                if (propose_account) {
                    transactionBuilder.add_type_operation("proposal_create", {
                        proposed_ops: [{ op: transfer_obj.transfer_op }],
                        fee_paying_account: transfer_obj.chain_propose_account.get("id")
                    });
                } else {
                    transactionBuilder.add_operation(transfer_obj.transfer_op);
                }
                return WalletDb.process_transaction(transactionBuilder, null, //signer_private_keys,
                broadcast);
            }).catch(function (err) {
                console.error(err);
            });
        });
    },
    transfer_list: function transfer_list(list_of_transfers) {
        var _this2 = this;

        return WalletUnlockActions.unlock().then(function () {
            var proposer = null;
            var transfers = [];
            var tr = new TransactionBuilder();
            list_of_transfers.forEach(function (transferData) {
                transferData.transactionBuilder = tr;
                transfers.push(_this2._create_transfer_op(transferData));
            });
            return Promise.all(transfers).then(function (result) {
                return tr.update_head_block().then(function () {
                    var propose = [];
                    result.forEach(function (item, idx) {
                        if (list_of_transfers[idx].propose_account) {
                            if (proposer == null) {
                                proposer = item.chain_propose_account;
                            }
                            propose.push({ op: item.transfer_op });
                        } else {
                            tr.add_operation(item.transfer_op);
                        }
                    });
                    tr.add_type_operation("proposal_create", {
                        proposed_ops: propose,
                        fee_paying_account: proposer.get("id")
                    });
                    return WalletDb.process_transaction(tr, null, //signer_private_keys,
                    true);
                });
            }).catch(function (err) {
                console.log(err);
            });
        });
    },
    issue_asset: function issue_asset(to_account, from_account, asset_id, amount, memo) {
        var encrypt_memo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
        var optional_nonce = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

        var unlock_promise = WalletUnlockActions.unlock();

        return Promise.all([FetchChain("getAccount", from_account), FetchChain("getAccount", to_account), unlock_promise]).then(function (res) {
            var _res3 = _slicedToArray(res, 2),
                chain_memo_sender = _res3[0],
                chain_to = _res3[1];

            var memo_from_public = void 0,
                memo_to_public = void 0;
            if (memo && encrypt_memo) {
                memo_from_public = chain_memo_sender.getIn(["options", "memo_key"]);

                // The 1s are base58 for all zeros (null)
                if (/111111111111111111111/.test(memo_from_public)) {
                    memo_from_public = null;
                }

                memo_to_public = chain_to.getIn(["options", "memo_key"]);
                if (/111111111111111111111/.test(memo_to_public)) {
                    memo_to_public = null;
                }
            }

            var memo_from_privkey = void 0;
            if (encrypt_memo && memo) {
                memo_from_privkey = WalletDb.getPrivateKey(memo_from_public);

                if (!memo_from_privkey) {
                    throw new Error("Missing private memo key for sender: " + from_account);
                }
            }

            var memo_object = void 0;
            if (memo && memo_to_public && memo_from_public) {
                var nonce = optional_nonce == null ? TransactionHelper.unique_nonce_uint64() : optional_nonce;

                memo_object = {
                    from: memo_from_public,
                    to: memo_to_public,
                    nonce: nonce,
                    message: encrypt_memo ? Aes.encrypt_with_checksum(memo_from_privkey, memo_to_public, nonce, memo) : Buffer.isBuffer(memo) ? memo.toString("utf-8") : memo
                };
            }

            var tr = new TransactionBuilder();
            tr.add_type_operation("asset_issue", {
                fee: {
                    amount: 0,
                    asset_id: 0
                },
                issuer: from_account,
                asset_to_issue: {
                    amount: amount,
                    asset_id: asset_id
                },
                issue_to_account: to_account,
                memo: memo_object
            });

            return WalletDb.process_transaction(tr, null, true);
        });
    },
    createWorker: function createWorker(options, account) {
        return new Promise(function (resolve, reject) {
            var tr = new TransactionBuilder();
            var core = ChainStore.getAsset("1.3.0");
            if (!core) reject(new Error("Can't find core asset, please try again"));
            var precision = Math.pow(10, core.get("precision"));

            var owner = ChainStore.getAccount(account).get("id");
            if (!owner) reject(new Error("Can't find the owner account, please try again"));

            try {
                tr.add_type_operation("worker_create", {
                    fee: {
                        amount: 0,
                        asset_id: 0
                    },
                    owner: owner,
                    work_begin_date: options.start,
                    work_end_date: options.end,
                    daily_pay: options.pay * precision,
                    name: options.title,
                    url: options.url,
                    initializer: [1, { pay_vesting_period_days: options.vesting }]
                });
            } catch (err) {
                reject(err);
            }
            WalletDb.process_transaction(tr, null, true).then(resolve).catch(reject);
        });
    },
    updateAccount: function updateAccount(updateObject) {
        var tr = new TransactionBuilder();
        tr.add_type_operation("account_update", updateObject);
        return WalletDb.process_transaction(tr, null, true);
    },


    /**
     * Fetches the account, no subscription
     *
     * @param account
     * @returns {Promise<{id}|Object>}
     * @private
     */
    _ensureAccount: function _ensureAccount(account) {
        var _this3 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!((typeof account === "undefined" ? "undefined" : _typeof(account)) == "object" && !!account.get("id"))) {
                                _context.next = 2;
                                break;
                            }

                            return _context.abrupt("return", account);

                        case 2:
                            _context.next = 4;
                            return FetchChain("getAccount", account, false);

                        case 4:
                            return _context.abrupt("return", _context.sent);

                        case 5:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    },
    _ensureAsset: function _ensureAsset(asset) {
        var _this4 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!((typeof asset === "undefined" ? "undefined" : _typeof(asset)) == "object" && !!asset.get("id"))) {
                                _context2.next = 2;
                                break;
                            }

                            return _context2.abrupt("return", asset);

                        case 2:
                            _context2.next = 4;
                            return FetchChain("getAsset", asset);

                        case 4:
                            return _context2.abrupt("return", _context2.sent);

                        case 5:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this4);
        }))();
    },


    /**
     * Create a withdrawal permission
     *
     * @async
     *
     * @param from - account granting the permission, can be id, name or account object
     * @param to - account claiming from the permission, can be id, name or account object
     * @param limitAsset - id of asset to claim, id or symbol
     * @param limitAssetAmount - int in satoshis, max amount to claim per period
     * @param periodInSeconds - how many seconds does one period last?
     * @param periodsUntilExpiration - how many periods will be done before expiration?
     * @param periodStartTime - dateobject or timestamp, when does the first period start? defaults to now
     * @param feeAsset - what asset to use for paying the fee, id or symbol
     * @returns {Promise<any>}
     */
    createWithdrawPermission: function createWithdrawPermission(from, to, limitAsset, limitAssetAmount, periodInSeconds, periodsUntilExpiration) {
        var periodStartTime = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;

        var _this5 = this;

        var feeAsset = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "1.3.0";
        var broadcast = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var objects, transactionBuilder, op;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            // default is now
                            if (periodStartTime == null) {
                                periodStartTime = new Date();
                            }
                            if (typeof periodStartTime == "number") {
                                periodStartTime = new Date(periodStartTime);
                            }

                            // account must be unlocked
                            _context3.next = 4;
                            return WalletUnlockActions.unlock();

                        case 4:
                            _context3.next = 6;
                            return _this5._ensureAccount(from);

                        case 6:
                            _context3.t0 = _context3.sent;
                            _context3.next = 9;
                            return _this5._ensureAccount(to);

                        case 9:
                            _context3.t1 = _context3.sent;
                            _context3.next = 12;
                            return _this5._ensureAsset(limitAsset);

                        case 12:
                            _context3.t2 = _context3.sent;
                            _context3.next = 15;
                            return _this5._ensureAsset(feeAsset);

                        case 15:
                            _context3.t3 = _context3.sent;
                            objects = {
                                from: _context3.t0,
                                to: _context3.t1,
                                limitAsset: _context3.t2,
                                feeAsset: _context3.t3
                            };
                            transactionBuilder = new TransactionBuilder();
                            op = transactionBuilder.get_type_operation("withdraw_permission_create", {
                                fee: {
                                    amount: 0,
                                    asset_id: objects.feeAsset.get("id")
                                },
                                withdraw_from_account: objects.from.get("id"),
                                authorized_account: objects.to.get("id"),
                                withdrawal_limit: {
                                    amount: limitAssetAmount,
                                    asset_id: objects.limitAsset.get("id")
                                },
                                withdrawal_period_sec: periodInSeconds,
                                periods_until_expiration: periodsUntilExpiration,
                                period_start_time: periodStartTime
                            });


                            transactionBuilder.add_operation(op);
                            _context3.next = 22;
                            return WalletDb.process_transaction(transactionBuilder, null, //signer_private_keys,
                            broadcast);

                        case 22:
                            if (transactionBuilder.tr_buffer) {
                                _context3.next = 24;
                                break;
                            }

                            throw "Something went finalization the transaction, this should not happen";

                        case 24:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, _this5);
        }))();
    },


    /**
     * Update a withdrawal permission
     *
     * @async
     *
     * @param withdrawPermissionId - permission to update
     * @param from - account granting the permission, can be id, name or account object
     * @param to - account claiming from the permission, can be id, name or account object
     * @param limitAsset - id of asset to claim, id or symbol
     * @param limitAssetAmount - int in satoshis, max amount to claim per period
     * @param periodInSeconds - how many seconds does one period last?
     * @param periodsUntilExpiration - how many periods will be done before expiration?
     * @param periodStartTime - dateobject or timestamp, when does the first period start? defaults to now
     * @param feeAsset - what asset to use for paying the fee, id or symbol
     * @returns {Promise<any>}
     */
    updateWithdrawPermission: function updateWithdrawPermission(withdrawPermissionId, from, to, limitAsset, limitAssetAmount, periodInSeconds, periodsUntilExpiration) {
        var periodStartTime = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

        var _this6 = this;

        var feeAsset = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : "1.3.0";
        var broadcast = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
            var objects, transactionBuilder, op;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            // default is now
                            if (periodStartTime == null) {
                                periodStartTime = new Date();
                            }
                            if (typeof periodStartTime == "number") {
                                periodStartTime = new Date(periodStartTime);
                            }

                            // account must be unlocked
                            _context4.next = 4;
                            return WalletUnlockActions.unlock();

                        case 4:
                            _context4.next = 6;
                            return _this6._ensureAccount(from);

                        case 6:
                            _context4.t0 = _context4.sent;
                            _context4.next = 9;
                            return _this6._ensureAccount(to);

                        case 9:
                            _context4.t1 = _context4.sent;
                            _context4.next = 12;
                            return _this6._ensureAsset(limitAsset);

                        case 12:
                            _context4.t2 = _context4.sent;
                            _context4.next = 15;
                            return _this6._ensureAsset(feeAsset);

                        case 15:
                            _context4.t3 = _context4.sent;
                            objects = {
                                from: _context4.t0,
                                to: _context4.t1,
                                limitAsset: _context4.t2,
                                feeAsset: _context4.t3
                            };
                            transactionBuilder = new TransactionBuilder();
                            op = transactionBuilder.get_type_operation("withdraw_permission_update", {
                                permission_to_update: withdrawPermissionId,
                                fee: {
                                    amount: 0,
                                    asset_id: objects.feeAsset.get("id")
                                },
                                withdraw_from_account: objects.from.get("id"),
                                authorized_account: objects.to.get("id"),
                                withdrawal_limit: {
                                    amount: limitAssetAmount,
                                    asset_id: objects.limitAsset.get("id")
                                },
                                withdrawal_period_sec: periodInSeconds,
                                periods_until_expiration: periodsUntilExpiration,
                                period_start_time: periodStartTime
                            });


                            transactionBuilder.add_operation(op);
                            _context4.next = 22;
                            return WalletDb.process_transaction(transactionBuilder, null, broadcast);

                        case 22:
                            if (transactionBuilder.tr_buffer) {
                                _context4.next = 24;
                                break;
                            }

                            throw "Something went finalization the transaction, this should not happen";

                        case 24:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, _this6);
        }))();
    },


    /**
     * Claim from a withdrawal permission
     *
     * @async
     *
     * @param withdrawPermissionId - id of the permission
     * @param from - account granting the permission, can be id, name or account object
     * @param to - account claiming from the permission, can be id, name or account object
     * @param claimAsset - id of asset to claim, id or symbol
     * @param claimAssetAmount - int in satoshis, max amount to claim per period
     * @param memo - optional memo
     * @param feeAsset - what asset to use for paying the fee, id or symbol
     * @returns {Promise<any>}
     */
    claimWithdrawPermission: function claimWithdrawPermission(withdrawPermissionId, from, to, claimAsset, claimAssetAmount) {
        var memo = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

        var _this7 = this;

        var feeAsset = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "1.3.0";
        var broadcast = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            var objects, memo_object, optional_nonce, encrypt_memo, memo_sender, memo_to, nonce, transactionBuilder, op;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return WalletUnlockActions.unlock();

                        case 2:
                            _context5.next = 4;
                            return _this7._ensureAccount(from);

                        case 4:
                            _context5.t0 = _context5.sent;
                            _context5.next = 7;
                            return _this7._ensureAccount(to);

                        case 7:
                            _context5.t1 = _context5.sent;
                            _context5.next = 10;
                            return _this7._ensureAsset(claimAsset);

                        case 10:
                            _context5.t2 = _context5.sent;
                            _context5.next = 13;
                            return _this7._ensureAsset(feeAsset);

                        case 13:
                            _context5.t3 = _context5.sent;
                            objects = {
                                from: _context5.t0,
                                to: _context5.t1,
                                claimAsset: _context5.t2,
                                feeAsset: _context5.t3
                            };
                            memo_object = void 0;
                            optional_nonce = null;
                            encrypt_memo = true;


                            if (memo) {
                                memo_sender = _this7._get_memo_keys(objects.to, true);
                                memo_to = _this7._get_memo_keys(objects.from, false);

                                if (!!memo_sender.public_key && !!memo_to.public_key) {
                                    nonce = optional_nonce == null ? TransactionHelper.unique_nonce_uint64() : optional_nonce;

                                    memo_object = {
                                        from: memo_sender.public_key,
                                        to: memo_to.public_key,
                                        nonce: nonce,
                                        message: encrypt_memo ? Aes.encrypt_with_checksum(memo_sender.private_key, memo_to.public_key, nonce, memo) : Buffer.isBuffer(memo) ? memo.toString("utf-8") : memo
                                    };
                                }
                            }

                            transactionBuilder = new TransactionBuilder();
                            op = transactionBuilder.get_type_operation("withdraw_permission_claim", {
                                fee: {
                                    amount: 0,
                                    asset_id: objects.feeAsset.get("id")
                                },
                                withdraw_permission: withdrawPermissionId,
                                withdraw_from_account: objects.from.get("id"),
                                withdraw_to_account: objects.to.get("id"),
                                amount_to_withdraw: {
                                    amount: claimAssetAmount,
                                    asset_id: objects.claimAsset.get("id")
                                },
                                memo: memo_object ? memo_object : undefined
                            });


                            transactionBuilder.add_operation(op);
                            _context5.next = 24;
                            return WalletDb.process_transaction(transactionBuilder, null, broadcast);

                        case 24:
                            if (transactionBuilder.tr_buffer) {
                                _context5.next = 26;
                                break;
                            }

                            throw "Something went finalization the transaction, this should not happen";

                        case 26:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this7);
        }))();
    },
    deleteWithdrawPermission: function deleteWithdrawPermission(withdrawPermissionId, from, to) {
        var _this8 = this;

        var feeAsset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "1.3.0";
        var broadcast = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
            var objects, transactionBuilder, op;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return WalletUnlockActions.unlock();

                        case 2:
                            _context6.next = 4;
                            return _this8._ensureAccount(from);

                        case 4:
                            _context6.t0 = _context6.sent;
                            _context6.next = 7;
                            return _this8._ensureAccount(to);

                        case 7:
                            _context6.t1 = _context6.sent;
                            _context6.next = 10;
                            return _this8._ensureAsset(feeAsset);

                        case 10:
                            _context6.t2 = _context6.sent;
                            objects = {
                                from: _context6.t0,
                                to: _context6.t1,
                                feeAsset: _context6.t2
                            };
                            transactionBuilder = new TransactionBuilder();
                            op = transactionBuilder.get_type_operation("withdraw_permission_delete", {
                                fee: {
                                    amount: 0,
                                    asset_id: objects.feeAsset.get("id")
                                },
                                withdrawal_permission: withdrawPermissionId,
                                withdraw_from_account: objects.from.get("id"),
                                authorized_account: objects.to.get("id")
                            });


                            transactionBuilder.add_operation(op);
                            _context6.next = 17;
                            return WalletDb.process_transaction(transactionBuilder, null, broadcast);

                        case 17:
                            if (transactionBuilder.tr_buffer) {
                                _context6.next = 19;
                                break;
                            }

                            throw "Something went finalization the transaction, this should not happen";

                        case 19:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, _this8);
        }))();
    }
};

export default ApplicationApi;